import { createEntityAdapter } from '@reduxjs/toolkit';

const iabCategoriesAdapter = createEntityAdapter();

export default iabCategoriesAdapter;
